// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_k4-0";
export var buttonContainer = "_k4-3";
export var cancelButton = "_k4-4";
export var headerSection = "_k4-6";
export var headerTitle = "_k4-9";
export var messageSideLeft = "_k4-1";
export var messageSideRight = "_k4-2";
export var orderNumberContainer = "_k4-7";
export var orderNumberLabel = "_k4-8";
export var submitButton = "_k4-5";